/* ==========================================================================
   BEUTE.STUDIO — prada.js · ein Skript für alles.
   Schichten (Menü/Suche/Warenkorb/Filter), Klappen, Reiter, Karussells mit
   Fortschrittsbalken, Produktseite, Filterblende, Größenwahl, Empfehlungen und
   Hinweisleiste des Warenkorbs, Countdown der Passwortseite. Texte kommen aus #prada-texte (Theme-Einstellungen).
   Bewegung: nur transform/opacity, Austritt schneller als Eintritt, unter 300 ms.
   Tastatur-Aktionen ohne Animation. Der Theme-Editor rendert Sektionen neu —
   deshalb initialisiert `starten(wurzel)` alles auch nachträglich.
   ========================================================================== */
(function () {
  'use strict';

  var d = document, w = window, de = d.documentElement;
  var reduziert = w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function geld(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function schuetzen(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function drossel(fn) {
    var laeuft = false;
    return function () {
      if (laeuft) return;
      laeuft = true;
      w.requestAnimationFrame(function () { laeuft = false; fn(); });
    };
  }

  /* Texte aus den Theme-Einstellungen; Rückfall, falls das JSON fehlt */
  var T = {
    leerTitel: 'Noch nichts drin.', leerText: 'Jedes Stück gibt es genau einmal — wer zögert, verpasst.',
    leerKnopf: 'Stücke ansehen', leerZiel: '/collections/all', entfernen: 'Entfernen', gr: 'Gr.',
    hinzu: 'Hinzufügen', hinzugefuegt: 'Hinzugefügt', fehler: 'Das hat nicht geklappt. Bitte noch einmal versuchen.',
    empfAn: true, empfTitel: 'Passt dazu', empfText: 'In deiner Größe, sofort lieferbar.',
    suchNichts: 'Nichts gefunden für', suchFehler: 'Die Suche ist gerade nicht erreichbar.', suchAlle: 'Alle Ergebnisse',
    suchUrl: '/search', grHinweis: 'Gefiltert nach deiner Größe', grAendern: 'Alle Größen anzeigen',
    versandFrei: 'Versand kostenlos', versandNoch: 'Noch {betrag} bis zum kostenlosen Versand'
  };
  try {
    var tj = d.getElementById('prada-texte');
    if (tj) { var geladen = JSON.parse(tj.textContent); Object.keys(geladen).forEach(function (k) { if (geladen[k] != null && geladen[k] !== '') T[k] = geladen[k]; }); }
  } catch (e) { /* Rückfall bleibt */ }

  var HAKEN = '<svg class="ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  de.classList.remove('no-js');
  de.classList.add('js-bereit');

  /* ========================================================================
     1 — SCHICHTEN: eine Stelle sperrt das Blättern, eine Stelle schaltet den Grund
     ======================================================================== */
  var offen = null;
  var scrollMerk = 0;
  var DAUER_AUS = 220;

  function grundSperren() {
    scrollMerk = w.scrollY;
    d.body.style.top = '-' + scrollMerk + 'px';
    d.body.classList.add('ist-gesperrt');
  }
  function grundFreigeben() {
    d.body.classList.remove('ist-gesperrt');
    d.body.style.top = '';
    w.scrollTo(0, scrollMerk);
  }

  function schichtOeffnen(id, ausloeser) {
    var el = d.getElementById(id);
    if (!el) return;
    if (offen === id) return;
    korbLeisteWeg();
    var warOffen = !!offen;
    if (offen) schichtSchliessen(true);
    offen = id;
    if (ausloeser) ausloeser.setAttribute('data-zuletzt-geoeffnet', '');
    el.hidden = false; void el.offsetWidth; el.classList.add('auf');
    var g = d.getElementById('grund-schleier');
    if (g) { g.hidden = false; void g.offsetWidth; g.classList.add('auf'); }
    if (!warOffen) grundSperren();
    $$('[aria-controls="' + id + '"]').forEach(function (k) { k.setAttribute('aria-expanded', 'true'); });
    w.setTimeout(function () {
      var ziel = el.querySelector('[data-fokus]') || el.querySelector('button, a, input');
      if (ziel) ziel.focus({ preventScroll: true });
    }, 60);
    if (id === 'korb-blende') empfehlungenLaden();
  }

  function schichtSchliessen(sofort) {
    if (!offen) return;
    var id = offen;
    offen = null;
    var el = d.getElementById(id);
    var g = d.getElementById('grund-schleier');
    if (el) {
      el.classList.remove('auf');
      if (sofort) { el.hidden = true; }
      else { w.setTimeout(function () { if (offen !== id) el.hidden = true; }, DAUER_AUS); }
    }
    if (g) {
      g.classList.remove('auf');
      if (sofort) { g.hidden = true; }
      else { w.setTimeout(function () { if (!offen) g.hidden = true; }, DAUER_AUS); }
    }
    $$('[aria-controls="' + id + '"]').forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
    if (!sofort) grundFreigeben();
    var auf = d.querySelector('[data-zuletzt-geoeffnet]');
    if (auf) { auf.removeAttribute('data-zuletzt-geoeffnet'); if (!sofort) auf.focus({ preventScroll: true }); }
  }

  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-schicht-auf]');
    if (k) {
      e.preventDefault();
      var id = k.getAttribute('data-schicht-auf');
      offen === id ? schichtSchliessen() : schichtOeffnen(id, k);
      return;
    }
    if (e.target.closest('[data-schliessen]') || e.target.id === 'grund-schleier') {
      e.preventDefault();
      schichtSchliessen();
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offen) schichtSchliessen();
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !offen) return;
    var el = d.getElementById(offen);
    if (!el) return;
    var f = $$('a[href], button:not([disabled]), input, select, textarea', el)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var erste = f[0], letzte = f[f.length - 1];
    if (e.shiftKey && d.activeElement === erste) { e.preventDefault(); letzte.focus(); }
    else if (!e.shiftKey && d.activeElement === letzte) { e.preventDefault(); erste.focus(); }
  });

  /* ========================================================================
     2 — KLAPPEN (Akkordeon): Höhe wird gemessen, nicht geraten
     ======================================================================== */
  function klappe(k, tastatur) {
    var ziel = d.getElementById(k.getAttribute('aria-controls'));
    if (!ziel) return;
    var auf = k.getAttribute('aria-expanded') === 'true';
    k.setAttribute('aria-expanded', auf ? 'false' : 'true');
    var sofort = tastatur || reduziert;
    if (auf) {
      if (sofort) { ziel.style.height = '0px'; ziel.hidden = true; return; }
      ziel.classList.add('zu');
      ziel.style.height = ziel.scrollHeight + 'px';
      void ziel.offsetWidth;
      ziel.style.height = '0px';
      ziel.addEventListener('transitionend', function ab() {
        ziel.hidden = true; ziel.classList.remove('zu');
        ziel.removeEventListener('transitionend', ab);
      });
    } else {
      ziel.hidden = false;
      if (sofort) { ziel.style.height = 'auto'; return; }
      ziel.style.height = '0px';
      void ziel.offsetWidth;
      ziel.style.height = ziel.scrollHeight + 'px';
      ziel.addEventListener('transitionend', function ab() {
        ziel.style.height = 'auto';
        ziel.removeEventListener('transitionend', ab);
      });
    }
  }
  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-klappe]');
    if (!k) return;
    e.preventDefault();
    klappe(k, e.detail === 0);
  });

  /* ========================================================================
     3 — REITER (Tabs)
     ======================================================================== */
  function reiterWaehlen(knopf, tastatur) {
    var wurzel = knopf.closest('[data-reiter-wurzel]');
    if (!wurzel) return;
    var id = knopf.getAttribute('data-reiter');
    $$('[data-reiter]', wurzel).forEach(function (r) {
      var an = r === knopf;
      r.setAttribute('aria-selected', an ? 'true' : 'false');
      r.setAttribute('tabindex', an ? '0' : '-1');
    });
    $$('[data-reiter-panel]', wurzel).forEach(function (p) {
      var an = p.getAttribute('data-reiter-panel') === id;
      if (an && p.hidden) {
        p.hidden = false;
        if (!tastatur && !reduziert) {
          p.classList.add('kommt');
          p.addEventListener('animationend', function ab() { p.classList.remove('kommt'); p.removeEventListener('animationend', ab); });
        }
      } else if (!an) {
        p.hidden = true; p.classList.remove('kommt');
      }
    });
    w.dispatchEvent(new Event('prada:layout'));
  }
  d.addEventListener('click', function (e) {
    var r = e.target.closest('[data-reiter]');
    if (!r) return;
    e.preventDefault();
    reiterWaehlen(r, e.detail === 0);
  });
  d.addEventListener('keydown', function (e) {
    var r = e.target.closest('[data-reiter]');
    if (!r || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var alle = $$('[data-reiter]', r.closest('[data-reiter-wurzel]'));
    var i = alle.indexOf(r) + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0 || i >= alle.length) return;
    e.preventDefault();
    alle[i].focus();
    reiterWaehlen(alle[i], true);
  });

  /* ========================================================================
     4 — KARUSSELL: Fortschrittsbalken (Breite = sichtbarer Anteil), Pfeile am PC
     ======================================================================== */
  var karussells = [];
  function karussellStarten(el) {
    if (el.dataset.karussellBereit === '1') return;
    el.dataset.karussellBereit = '1';
    var spur = el.querySelector('[data-spur]');
    var balken = el.querySelector('[data-balken]');
    var segmente = $$('[data-segment]', el);
    var zurueck = el.querySelector('[data-zurueck]');
    var weiter = el.querySelector('[data-weiter]');
    if (!spur) return;
    function stand() {
      var breite = spur.scrollWidth, sicht = spur.clientWidth, x = spur.scrollLeft;
      if (!breite || !sicht) return;
      var anteil = Math.min(1, sicht / breite);
      if (balken) {
        balken.style.transform = 'translateX(' + ((x / breite) * 100).toFixed(3) + '%) scaleX(' + anteil.toFixed(4) + ')';
        balken.parentNode.hidden = anteil >= 0.999;
      }
      if (segmente.length) {
        var i = Math.round(x / sicht);
        segmente.forEach(function (s, j) { s.classList.toggle('ist-aktiv', j === i); });
      }
      if (zurueck) zurueck.disabled = x <= 2;
      if (weiter) weiter.disabled = x + sicht >= breite - 2;
    }
    spur.addEventListener('scroll', drossel(stand), { passive: true });
    if (zurueck) zurueck.addEventListener('click', function () { spur.scrollBy({ left: -spur.clientWidth * 0.8, behavior: reduziert ? 'auto' : 'smooth' }); });
    if (weiter) weiter.addEventListener('click', function () { spur.scrollBy({ left: spur.clientWidth * 0.8, behavior: reduziert ? 'auto' : 'smooth' }); });
    karussells.push(stand);
    stand();
  }
  function karussellsMessen() { karussells.forEach(function (f) { f(); }); }
  w.addEventListener('resize', drossel(karussellsMessen));
  w.addEventListener('prada:layout', function () { w.setTimeout(karussellsMessen, 20); });
  w.addEventListener('load', karussellsMessen);

  /* ========================================================================
     6 — SUCHE
     ======================================================================== */
  (function suche() {
    var abbruch = null, warte = null;
    d.addEventListener('input', function (e) {
      var feld = e.target.closest('[data-such-feld]');
      if (!feld) return;
      var wort = feld.value.trim();
      var raum = d.getElementById('such-treffer');
      if (!raum) return;
      w.clearTimeout(warte);
      if (wort.length < 2) { raum.innerHTML = ''; raum.dataset.zustand = 'leer'; return; }
      raum.dataset.zustand = 'laedt';
      warte = w.setTimeout(function () {
        if (abbruch) abbruch.abort();
        abbruch = new AbortController();
        var url = T.suchUrl + '/suggest.json?q=' + encodeURIComponent(wort) + '&resources[type]=product&resources[limit]=6';
        fetch(url, { signal: abbruch.signal })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var tr = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!tr.length) {
              raum.dataset.zustand = 'nichts';
              raum.innerHTML = '<p class="such-nichts">' + schuetzen(T.suchNichts) + ' „' + schuetzen(wort) + '".</p>';
              return;
            }
            raum.dataset.zustand = 'treffer';
            raum.innerHTML = tr.map(function (p) {
              var bild = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              var preis = p.price != null && String(p.price).length
                ? (isNaN(parseFloat(p.price)) ? p.price : parseFloat(p.price).toFixed(2).replace('.', ',') + ' €') : '';
              return '<a class="such-treffer" href="' + schuetzen(p.url) + '">' +
                (bild ? '<img src="' + schuetzen(bild) + '&width=120" alt="" width="48" height="60">' : '<span class="such-treffer__ph"></span>') +
                '<span class="such-treffer__text">' +
                  '<span class="such-treffer__marke">' + schuetzen(p.vendor || '') + '</span>' +
                  '<span class="such-treffer__name">' + schuetzen(p.title) + '</span>' +
                '</span>' +
                '<span class="such-treffer__preis">' + schuetzen(preis) + '</span>' +
              '</a>';
            }).join('') +
            '<a class="such__alle textlink" href="' + schuetzen(T.suchUrl) + '?type=product&q=' + encodeURIComponent(wort) + '">' + schuetzen(T.suchAlle) + '</a>';
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            raum.dataset.zustand = 'nichts';
            raum.innerHTML = '<p class="such-nichts">' + schuetzen(T.suchFehler) + '</p>';
          });
      }, 180);
    });
  })();

  /* ========================================================================
     7 — GRÖSSEN: Hilfen für Karten, Warenkorb und Empfehlungen
     ======================================================================== */
  var GROESSEN = ['XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL'];
  function groesseVon(text) {
    var t = String(text || '').toUpperCase().trim();
    if (GROESSEN.indexOf(t) < 0) return null;
    if (t === 'XXL') return '2XL';
    if (t === 'XXXL') return '3XL';
    return t;
  }
  function produktGroessen(p) {
    var s = [];
    (p.variants || []).forEach(function (v) {
      [v.option1, v.option2, v.option3].forEach(function (o) { var g = groesseVon(o); if (g && s.indexOf(g) < 0) s.push(g); });
    });
    (p.tags || []).forEach(function (t) {
      var m = /^groesse-(.+)$/i.exec(String(t)); if (m) { var g = groesseVon(m[1]); if (g && s.indexOf(g) < 0) s.push(g); }
    });
    return s;
  }
  function gruppeVon(typ, titel) {
    var t = (String(typ || '') + ' ' + String(titel || '')).toLowerCase();
    if (/jacke|jacket|windbreaker|anorak|weste|mantel|parka/.test(t)) return 'jacke';
    if (/hose|short|jogg|pants|track|jeans|cargo/.test(t)) return 'unten';
    return 'oben';
  }

  /* Meine Größe: einmal wählen, überall zuerst passende Stücke sehen */
  var SCHLUESSEL = 'beute_groesse';
  function meineGroesse() { try { return groesseVon(localStorage.getItem(SCHLUESSEL)) || ''; } catch (e) { return ''; } }
  function groesseMerken(g) { try { g ? localStorage.setItem(SCHLUESSEL, g) : localStorage.removeItem(SCHLUESSEL); } catch (e) { /* privat */ } }

  function groessenAnwenden() {
    var g = meineGroesse();
    $$('[data-groessen-filter]').forEach(function (wurzel) {
      var sichtbar = 0;
      $$('[data-sizes]', wurzel).forEach(function (k) {
        var passt = !g || (k.getAttribute('data-sizes') || '').indexOf('|' + g + '|') > -1;
        k.hidden = !passt;
        if (passt) sichtbar++;
      });
      var leer = wurzel.querySelector('[data-groessen-leer]');
      if (leer) leer.hidden = !g || sichtbar > 0;
    });
    $$('[data-groesse-chip]').forEach(function (c) { c.classList.toggle('groesse--gewaehlt', (c.getAttribute('data-groesse-chip') || '') === g); c.setAttribute('aria-pressed', (c.getAttribute('data-groesse-chip') || '') === g ? 'true' : 'false'); });
    w.dispatchEvent(new Event('prada:layout'));
  }
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-groesse-chip]');
    if (!c) return;
    e.preventDefault();
    var g = groesseVon(c.getAttribute('data-groesse-chip')) || '';
    groesseMerken(g === meineGroesse() ? '' : g);   /* zweiter Klick hebt die Wahl auf */
    groessenAnwenden();
  });

  /* ========================================================================
     8 — WARENKORB: Inhalt steht beim ersten Öffnen schon im Markup
     ======================================================================== */
  var letzterKorb = null;
  function zahlSetzen(n, hüpfen) {
    $$('[data-korb-zahl]').forEach(function (b) {
      b.textContent = n; b.hidden = n < 1;
      if (hüpfen && !reduziert) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
  }
  function versandSetzen(korb) {
    var el = d.getElementById('korb-versand');
    if (!el) return;
    var grenze = parseInt(el.dataset.grenze || '0', 10);
    if (grenze <= 0) return;
    var rest = grenze - korb.total_price;
    var band = el.querySelector('.korb-versand__fuell');
    if (band) band.style.transform = 'scaleX(' + Math.min(1, korb.total_price / grenze).toFixed(3) + ')';
    var txt = el.querySelector('.korb-versand__text');
    if (txt) txt.textContent = rest <= 0 ? T.versandFrei : T.versandNoch.replace('{betrag}', geld(rest));
  }
  function korbGroesse(p) {
    var g = null;
    (p.variant_options || []).forEach(function (o) { g = g || groesseVon(o); });
    (p.options_with_values || []).forEach(function (o) { g = g || groesseVon(o.value); });
    return g;
  }
  function zeichnen(korb, hüpfen) {
    letzterKorb = korb;
    zahlSetzen(korb.item_count, hüpfen);
    versandSetzen(korb);
    var fuss = d.getElementById('korb-fuss');
    var liste = d.getElementById('korb-liste');
    var einzel = d.getElementById('korb-einzel');
    if (einzel) einzel.hidden = !korb.item_count;
    if (!liste) return;
    if (!korb.item_count) {
      liste.innerHTML =
        '<div class="korb-leer">' +
          '<p class="korb-leer__wort">' + schuetzen(T.leerTitel) + '</p>' +
          '<p class="korb-leer__satz">' + schuetzen(T.leerText) + '</p>' +
          '<a class="knopf knopf--rand" href="' + schuetzen(T.leerZiel) + '">' + schuetzen(T.leerKnopf) + '</a>' +
        '</div>';
      if (fuss) fuss.hidden = true;
      $$('[data-korb-empfehlungen]').forEach(function (e0) { e0.hidden = true; e0.innerHTML = ''; });
      return;
    }
    if (fuss) fuss.hidden = false;
    liste.innerHTML = korb.items.map(function (p) {
      var bild = p.featured_image && p.featured_image.url
        ? '<img class="korb-stueck__bild" src="' + schuetzen(p.featured_image.url) + '&width=200" alt="" width="72" height="90">'
        : '<span class="korb-stueck__bild korb-stueck__bild--ph"></span>';
      var g = korbGroesse(p);
      var variante = g ? '<p class="korb-stueck__var">' + schuetzen(T.gr) + ' ' + schuetzen(g) + '</p>'
        : ((p.variant_title && p.variant_title !== 'Default Title') ? '<p class="korb-stueck__var">' + schuetzen(p.variant_title) + '</p>' : '');
      var marke = p.vendor && String(p.product_title || '').toLowerCase().indexOf(String(p.vendor).toLowerCase()) === -1
        ? '<p class="korb-stueck__marke">' + schuetzen(p.vendor) + '</p>' : '';
      return '<article class="korb-stueck" data-schluessel="' + schuetzen(p.key) + '">' +
        '<a class="korb-stueck__bildlink" href="' + schuetzen(p.url) + '">' + bild + '</a>' +
        '<div class="korb-stueck__text">' + marke +
          '<a class="korb-stueck__name" href="' + schuetzen(p.url) + '">' + schuetzen(p.product_title) + '</a>' +
          variante +
          '<div class="korb-stueck__reihe">' +
            '<span class="korb-stueck__preis">' + geld(p.final_line_price != null ? p.final_line_price : p.line_price) + '</span>' +
            '<button class="korb-stueck__weg" type="button" data-korb-weg="' + schuetzen(p.key) + '">' + schuetzen(T.entfernen) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
    var summe = d.getElementById('korb-summe');
    if (summe) summe.textContent = geld(korb.total_price);
    empfehlungenLaden(true);
  }
  function holen(pfad, daten) {
    return fetch(pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (r) { return r.json(); });
  }
  function korbLaden() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-korb-weg]');
    if (!b) return;
    e.preventDefault();
    var stueck = b.closest('.korb-stueck');
    if (stueck) stueck.classList.add('geht');
    holen('/cart/change.js', { id: b.getAttribute('data-korb-weg'), quantity: 0 })
      .then(function (k) { zeichnen(k, false); })
      .catch(function () { if (stueck) stueck.classList.remove('geht'); });
  });

  /* Leiste unter dem Kopf: „Stück — Im Warenkorb · Ansehen“ statt aufspringender Schublade */
  var leisteUhr = null;
  function korbLeisteZeigen(titel) {
    var el = d.getElementById('korb-leiste');
    if (!el) return false;
    var text = el.querySelector('[data-leiste-text]');
    if (text) text.innerHTML = (titel ? '<strong>' + schuetzen(titel) + '</strong> — ' : '') + schuetzen(T.leisteText);
    el.hidden = false; void el.offsetWidth; el.classList.add('auf');
    w.clearTimeout(leisteUhr);
    leisteUhr = w.setTimeout(korbLeisteWeg, 4500);
    return true;
  }
  function korbLeisteWeg() {
    var el = d.getElementById('korb-leiste');
    if (!el || !el.classList.contains('auf')) return;
    el.classList.remove('auf');
    w.clearTimeout(leisteUhr);
    w.setTimeout(function () { if (!el.classList.contains('auf')) el.hidden = true; }, DAUER_AUS);
  }

  /* Erfolg am Knopf: kurz „Hinzugefügt“ mit Haken, dann zurück */
  function erfolgZeigen(knopf) {
    if (!knopf) return;
    var alt = knopf.innerHTML;
    knopf.classList.add('knopf--erfolg');
    knopf.innerHTML = HAKEN + '<span>' + schuetzen(T.hinzugefuegt) + '</span>';
    w.setTimeout(function () { knopf.classList.remove('knopf--erfolg'); knopf.innerHTML = alt; }, 1600);
  }

  /* Hinzufügen — jedes Formular, das auf /cart/add zeigt */
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var knopf = form.querySelector('[type="submit"]');
    if (knopf) { knopf.disabled = true; knopf.classList.add('laedt'); }
    var knopfFrei = function () { if (knopf) { knopf.disabled = false; knopf.classList.remove('laedt'); } };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Fehler'); });
        return r.json();
      })
      .then(function (stueck) { return korbLaden().then(function (korb) { return { stueck: stueck, korb: korb }; }); })
      .then(function (x) {
        knopfFrei(); erfolgZeigen(knopf); zeichnen(x.korb, true);
        var titel = x.stueck && (x.stueck.product_title || (x.stueck.items && x.stueck.items[0] && x.stueck.items[0].product_title));
        if (T.korbVerhalten === 'schublade' || !korbLeisteZeigen(titel)) schichtOeffnen('korb-blende', knopf);
      })
      .catch(function (err) { knopfFrei(); melden(err.message === 'Fehler' ? T.fehler : err.message); });
  });

  var start = d.getElementById('korb-daten');
  if (start) zahlSetzen(parseInt(start.dataset.zahl || '0', 10), false);

  /* ========================================================================
     9 — EMPFEHLUNGEN IM WARENKORB
     Gleiche Größe zuerst, dann das fehlende Teil zum Outfit (Oberteil ↔ Hose ↔ Jacke),
     gleiche Marke leicht bevorzugt. Quelle: Shopify-Empfehlungen zu den Stücken im
     Korb plus die lieferbare Ware. Nichts wird behauptet, was nicht da ist.
     ======================================================================== */
  var poolCache = null, empfLaeuft = false;

  function poolLaden(korb) {
    if (poolCache) return Promise.resolve(poolCache);
    var quellen = korb.items.slice(0, 2).map(function (p) {
      return fetch('/recommendations/products.json?product_id=' + p.product_id + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    });
    quellen.push(
      fetch('/collections/lieferbar/products.json?limit=50', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; })
    );
    return Promise.all(quellen).then(function (listen) {
      var alle = [], gesehen = {};
      listen.forEach(function (l) { l.forEach(function (p) { if (p && p.id && !gesehen[p.id]) { gesehen[p.id] = 1; alle.push(p); } }); });
      poolCache = alle;
      return alle;
    });
  }

  function empfehlungenLaden(neu) {
    var raeume = $$('[data-korb-empfehlungen]');
    if (!raeume.length || !T.empfAn) return;
    if (empfLaeuft && !neu) return;
    var vorlage = letzterKorb ? Promise.resolve(letzterKorb) : korbLaden();
    empfLaeuft = true;
    vorlage.then(function (korb) {
      letzterKorb = korb;
      if (!korb.item_count) { raeume.forEach(function (r) { r.hidden = true; r.innerHTML = ''; }); empfLaeuft = false; return; }
      return poolLaden(korb).then(function (pool) {
        var imKorb = {}, groessen = [], gruppen = [], marken = [];
        korb.items.forEach(function (p) {
          imKorb[p.product_id] = 1;
          var g = korbGroesse(p); if (g && groessen.indexOf(g) < 0) groessen.push(g);
          gruppen.push(gruppeVon(p.product_type, p.product_title));
          if (p.vendor) marken.push(String(p.vendor).toLowerCase());
        });
        var kandidaten = pool.map(function (p) {
          if (imKorb[p.id]) return null;
          var varianten = (p.variants || []).filter(function (v) { return v.available !== false; });
          if (!varianten.length) return null;
          var passende = varianten.filter(function (v) { return [v.option1, v.option2, v.option3].some(function (o) { var g = groesseVon(o); return g && groessen.indexOf(g) > -1; }); });
          var variante = passende[0] || varianten[0];
          var punkte = 0;
          if (passende.length) punkte += 4;
          else if (groessen.length) punkte -= 3;
          var gr = gruppeVon(p.product_type || p.type, p.title);
          if (gruppen.indexOf(gr) < 0) punkte += 3; else punkte -= 1;
          if (p.vendor && marken.indexOf(String(p.vendor).toLowerCase()) > -1) punkte += 1;
          var preis = typeof variante.price === 'number' ? variante.price : Math.round(parseFloat(variante.price) * 100);
          var bild = (p.featured_image) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
          var groesse = null;
          [variante.option1, variante.option2, variante.option3].forEach(function (o) { groesse = groesse || groesseVon(o); });
          return { p: p, v: variante, punkte: punkte, preis: preis, bild: bild, groesse: groesse };
        }).filter(Boolean);
        kandidaten.sort(function (a, b) { return b.punkte - a.punkte || (b.p.id - a.p.id); });
        var wahl = kandidaten.slice(0, Math.min(4, Math.max(1, parseInt(T.empfAnzahl, 10) || 2)));
        if (!wahl.length) { raeume.forEach(function (r) { r.hidden = true; r.innerHTML = ''; }); empfLaeuft = false; return; }
        var markup =
          '<p class="empf__titel">' + schuetzen(T.empfTitel) + '</p>' +
          (T.empfText ? '<p class="empf__text">' + schuetzen(T.empfText) + '</p>' : '') +
          '<div class="empf__liste">' + wahl.map(function (k, i) {
            var url = k.p.url || ('/products/' + k.p.handle);
            var bild = k.bild ? '<img class="empf__bild" src="' + schuetzen(k.bild) + (String(k.bild).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="56" height="70" loading="lazy">' : '<span class="empf__bild"></span>';
            return '<div class="empf__stueck" style="--i:' + i + '">' +
              '<a href="' + schuetzen(url) + '">' + bild + '</a>' +
              '<div><a class="empf__name" href="' + schuetzen(url) + '">' + schuetzen(k.p.title) + '</a>' +
                '<p class="empf__meta">' + (k.groesse ? schuetzen(T.gr) + ' ' + schuetzen(k.groesse) + ' · ' : '') + geld(k.preis) + '</p></div>' +
              '<button class="empf__knopf" type="button" data-empf-hinzu="' + k.v.id + '">' + schuetzen(T.hinzu) + '</button>' +
            '</div>';
          }).join('') + '</div>';
        raeume.forEach(function (r) { r.hidden = false; r.innerHTML = markup; });
        empfLaeuft = false;
      });
    }).catch(function () { empfLaeuft = false; });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-empf-hinzu]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('laedt'); b.disabled = true;
    holen('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-empf-hinzu'), 10), quantity: 1 }] })
      .then(function (j) {
        if (j && j.status && j.status >= 400) throw new Error(j.description || 'Fehler');
        b.classList.remove('laedt'); b.classList.add('ist-drin'); b.textContent = T.hinzugefuegt;
        return korbLaden();
      })
      .then(function (korb) { zeichnen(korb, true); })
      .catch(function (err) { b.classList.remove('laedt'); b.disabled = false; melden(err.message === 'Fehler' ? T.fehler : err.message); });
  });

  /* ========================================================================
     10 — MELDUNG
     ======================================================================== */
  var meldeUhr = null;
  function melden(text) {
    var el = d.getElementById('meldung');
    if (!el) return;
    el.textContent = text;
    el.classList.add('auf');
    w.clearTimeout(meldeUhr);
    meldeUhr = w.setTimeout(function () { el.classList.remove('auf'); }, 3200);
  }
  w.beuteMelden = melden;

  /* ========================================================================
     11 — PRODUKTSEITE: Größe wählen, Preis/Rabatt nachziehen
     ======================================================================== */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-groesse]');
    if (!b || b.disabled) return;
    var wurzel = b.closest('[data-produkt]') || d;
    $$('button[data-groesse]', wurzel).forEach(function (o) {
      o.classList.toggle('groesse--gewaehlt', o === b);
      o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
    });
    var id = wurzel.querySelector('[data-varianten-id]');
    if (id) id.value = b.dataset.vid;
    var preis = wurzel.querySelector('[data-preis]');
    if (preis) preis.textContent = b.dataset.price;
    var vorher = wurzel.querySelector('[data-vorher]');
    var rabatt = wurzel.querySelector('[data-rabatt]');
    if (vorher) { vorher.textContent = b.dataset.cmp || ''; vorher.hidden = !b.dataset.cmp; }
    if (rabatt) { rabatt.textContent = b.dataset.pct ? '−' + b.dataset.pct + ' %' : ''; rabatt.hidden = !b.dataset.pct; }
  });

  /* ========================================================================
     12 — KOLLEKTION: Filtern und Sortieren (URL-Parameter bleiben), Größe merken
     ======================================================================== */
  function kollektionStarten(wurzel) {
    if (wurzel.dataset.filterBereit === '1') return;
    wurzel.dataset.filterBereit = '1';
    var grid = wurzel.querySelector('[data-produkt-raster]');
    var leer = wurzel.querySelector('[data-leer]');
    var hinweis = wurzel.querySelector('[data-groesse-hinweis]');
    var anzahlen = $$('[data-anzahl]', wurzel);
    if (!grid) return;
    var params = new URLSearchParams(w.location.search);
    var aktiv = { brand: params.get('filter_brand') || '*', size: params.get('filter_size') || '*' };
    var automatisch = false;

    /* Ohne Filter in der Adresse: gemerkte Größe anwenden — sichtbar, mit Ausweg */
    var gemerkt = meineGroesse();
    if (aktiv.size === '*' && gemerkt && wurzel.dataset.groesseAuto === '1' && wurzel.querySelector('[data-f="size"][data-v="' + gemerkt + '"]')) {
      aktiv.size = gemerkt; automatisch = true;
    }

    function chipsSetzen() {
      $$('[data-f]', wurzel).forEach(function (c) { c.classList.toggle('ist-aktiv', aktiv[c.dataset.f] === c.dataset.v); });
      if (hinweis) {
        hinweis.hidden = !(automatisch && aktiv.size !== '*');
        if (!hinweis.hidden) hinweis.innerHTML = schuetzen(T.grHinweis) + ' <strong>' + schuetzen(aktiv.size) + '</strong> · <a href="#" data-groesse-aufheben>' + schuetzen(T.grAendern) + '</a>';
      }
    }
    function urlSetzen(ersetzen) {
      var url = new URL(w.location.href);
      if (aktiv.brand !== '*') url.searchParams.set('filter_brand', aktiv.brand); else url.searchParams.delete('filter_brand');
      if (aktiv.size !== '*' && !automatisch) url.searchParams.set('filter_size', aktiv.size); else url.searchParams.delete('filter_size');
      if (ersetzen) history.replaceState(null, '', url.toString());
      return url;
    }
    function anwenden() {
      var n = 0;
      Array.prototype.forEach.call(grid.children, function (item) {
        var bOk = aktiv.brand === '*' || (item.dataset.brand || '') === aktiv.brand;
        var sOk = aktiv.size === '*' || (item.dataset.sizes || '').indexOf('|' + aktiv.size + '|') > -1;
        var zeigen = bOk && sOk;
        item.hidden = !zeigen;
        if (zeigen) n++;
      });
      if (leer) leer.hidden = n !== 0;
      anzahlen.forEach(function (a) { a.textContent = n; });
    }
    wurzel.addEventListener('click', function (e) {
      var auf = e.target.closest('[data-groesse-aufheben]');
      if (auf) { e.preventDefault(); aktiv.size = '*'; automatisch = false; groesseMerken(''); chipsSetzen(); urlSetzen(true); anwenden(); return; }
      var c = e.target.closest('[data-f]');
      if (!c) return;
      e.preventDefault();
      aktiv[c.dataset.f] = c.dataset.v;
      if (c.dataset.f === 'size') { automatisch = false; if (c.dataset.v !== '*') groesseMerken(c.dataset.v); }
      chipsSetzen(); urlSetzen(true); anwenden();
    });
    Array.prototype.forEach.call(wurzel.querySelectorAll('input[name="sort_by"]'), function (r) {
      r.addEventListener('change', function () {
        var url = urlSetzen(false);
        url.searchParams.set('sort_by', r.value);
        w.location.href = url.toString();
      });
    });
    var zuruecksetzen = wurzel.querySelector('[data-filter-reset]');
    if (zuruecksetzen) zuruecksetzen.addEventListener('click', function () {
      aktiv.brand = '*'; aktiv.size = '*'; automatisch = false;
      chipsSetzen(); urlSetzen(true); anwenden();
    });
    chipsSetzen(); anwenden();
  }

  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-filter-ziel]');
    if (!k) return;
    var ziel = d.getElementById(k.getAttribute('data-filter-ziel'));
    if (!ziel) return;
    w.setTimeout(function () { ziel.scrollIntoView({ block: 'start', behavior: 'auto' }); }, 80);
  });

  /* ========================================================================
     13 — BILDER sanft aufblenden, sobald sie da sind
     ======================================================================== */
  function bildDa(img) { img.classList.add('bild-da'); }
  function bildFassen(img) {
    if (img.getAttribute('loading') !== 'lazy') return;
    if (img.dataset.bildGefasst === '1') return;
    img.dataset.bildGefasst = '1';
    if (img.complete) { bildDa(img); return; }
    img.addEventListener('load', function () { bildDa(img); }, { once: true });
    img.addEventListener('error', function () { bildDa(img); }, { once: true });
  }

  /* ========================================================================
     13b — COUNTDOWN (geschlossener Shop): Ziel „TT.MM.JJJJ HH:MM“ oder ISO-Datum,
     zählt jede Sekunde; abgelaufen → Zahlen weg, Ende-Text sichtbar
     ======================================================================== */
  function zielLesen(text) {
    var t = String(text || '').trim();
    var m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\D+(\d{1,2})[:.](\d{2}))?$/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], m[4] ? +m[4] : 0, m[5] ? +m[5] : 0, 0).getTime();
    var iso = Date.parse(t);
    return isNaN(iso) ? null : iso;
  }
  function countdownStarten(el) {
    if (el.dataset.cdBereit === '1') return;
    el.dataset.cdBereit = '1';
    var ziel = zielLesen(el.getAttribute('data-countdown'));
    var ende = el.parentNode ? el.parentNode.querySelector('[data-cd-ende]') : null;
    var feld = {};
    ['t', 'h', 'm', 's'].forEach(function (k) { feld[k] = el.querySelector('[data-cd="' + k + '"]'); });
    if (ziel == null) { el.hidden = true; return; }
    function zwei(n) { return (n < 10 ? '0' : '') + n; }
    var uhr = null;
    function tick() {
      var rest = ziel - Date.now();
      if (rest <= 0) {
        el.hidden = true; if (ende) ende.hidden = false;
        if (uhr) w.clearInterval(uhr);
        return;
      }
      var s = Math.floor(rest / 1000);
      if (feld.t) feld.t.textContent = zwei(Math.floor(s / 86400));
      if (feld.h) feld.h.textContent = zwei(Math.floor((s % 86400) / 3600));
      if (feld.m) feld.m.textContent = zwei(Math.floor((s % 3600) / 60));
      if (feld.s) feld.s.textContent = zwei(s % 60);
    }
    tick();
    uhr = w.setInterval(tick, 1000);
  }

  /* ========================================================================
     14 — START (auch nach Neuaufbau einer Sektion im Theme-Editor)
     ======================================================================== */
  function starten(wurzel) {
    wurzel = wurzel || d;
    $$('img[loading="lazy"]', wurzel).forEach(bildFassen);
    $$('[data-karussell]', wurzel).forEach(karussellStarten);
    $$('[data-countdown]', wurzel).forEach(countdownStarten);
    $$('[data-kollektion]', wurzel).forEach(kollektionStarten);
    groessenAnwenden();
  }
  starten();

  if ('MutationObserver' in w) {
    new w.MutationObserver(function (eintraege) {
      var neue = [];
      eintraege.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (k) {
          if (!k || k.nodeType !== 1) return;
          if (k.tagName === 'IMG') { neue.push(k); return; }
          if (!k.querySelectorAll) return;
          var innen = k.querySelectorAll('img[loading="lazy"]');
          if (innen.length) Array.prototype.push.apply(neue, Array.prototype.slice.call(innen));
        });
      });
      neue.forEach(bildFassen);
    }).observe(d.body, { childList: true, subtree: true });
  }

  d.addEventListener('shopify:section:load', function (e) { starten(e.target); });
  d.addEventListener('shopify:section:unload', function () { if (offen) schichtSchliessen(true); });
  d.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.closest) return;
    var panel = e.target.closest('[data-reiter-panel]');
    if (panel && panel.hidden) {
      var knopf = d.querySelector('[data-reiter="' + panel.getAttribute('data-reiter-panel') + '"]');
      if (knopf) reiterWaehlen(knopf, true);
    }
    var stueck = e.target.closest('.karussell__stueck, .hero__slide');
    if (stueck && stueck.scrollIntoView) stueck.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'auto' });
  });

  if (reduziert) {
    $$('video[autoplay]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* Kopf über dem Auftakt: durchsichtig, solange das Bild unter ihm liegt — dann deckend */
  (function kopfSchweben() {
    var wrap = d.querySelector('[data-kopf].kopf-wrap--schwebt');
    if (!wrap) return;
    function stand() {
      var hero = d.querySelector('[data-hero]');
      var fest = !hero || hero.getBoundingClientRect().bottom <= wrap.offsetHeight + 8;
      wrap.classList.toggle('ist-fest', fest);
    }
    w.addEventListener('scroll', stand, { passive: true });
    w.addEventListener('resize', drossel(stand));
    d.addEventListener('shopify:section:load', function () { w.setTimeout(stand, 50); });
    stand();
  })();

  /* Rückgabe: Bestellnummer aus der Adresse vorbelegen (?bestellung=1042) */
  (function rueckgabeVorbelegen() {
    var feld = d.getElementById('rueck-nr');
    if (!feld || feld.value) return;
    var nr = new URLSearchParams(w.location.search).get('bestellung');
    if (nr) feld.value = nr.charAt(0) === '#' ? nr : '#' + nr;
  })();

  /* Warenkorbseite: Empfehlungen sofort füllen (in der Schublade erst beim Öffnen) */
  if (d.body.classList.contains('template-cart') && $$('[data-korb-empfehlungen]').length) empfehlungenLaden(true);

})();
